module.exports = __webpack_public_path__ + "static/media/list-ul.df9d23f1.svg";